module.exports = __webpack_public_path__ + "img/3.f8b942b9.png";